import { render, staticRenderFns } from "./roleDeptRelationship.vue?vue&type=template&id=8cd394cc&scoped=true&"
import script from "./roleDeptRelationship.vue?vue&type=script&lang=js&"
export * from "./roleDeptRelationship.vue?vue&type=script&lang=js&"
import style0 from "./roleDeptRelationship.vue?vue&type=style&index=0&id=8cd394cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd394cc",
  null
  
)

export default component.exports